import m from "../../geodata/es2015/saoTomePrincipeLow";
window.am4geodata_saoTomePrincipeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saoTomePrincipeLow.js
// module id = null
// module chunks = 